import React, { useState } from 'react'

// MUI
import {
  Grid, Typography, Button,
  Dialog, DialogContent, DialogTitle, DialogActions
} from '@material-ui/core'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../tools/UnitTree'
import { keyify2 } from '../../../utils'
import { HandleSingleUnitClick } from '../../../utils/functions/unitFunctions'

const OUAlertSelectionModal = (props) => {
  const {
    openUnits = false, handleOUCancel = () => { }, classes = {}, GreenCheckbox, newUnitAlerts, setNewUnitAlerts = () => { }, noSMS, TreeData,
    noUnit = false, noDeliveryMethod = false, handleOUOk = () => { }
  } = props

  const [expandedKeys] = useState(keyify2(TreeData))

  // This handles the user selecting the sms check in the OU and switches the sensSMS element  (this is passed directly from original logic into this new component. For the record, I don't like it and want to redo it. - Cat)
  const ouSmsCheck = () => {
    if (newUnitAlerts) {
      if (!newUnitAlerts.sendSMS && !newUnitAlerts.sendEmail) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendSMS: true,
          isSubscribed: true
        })
      } else if (!newUnitAlerts.sendSMS && newUnitAlerts.sendEmail) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendSMS: true
        })
      } else if (newUnitAlerts.sendSMS && newUnitAlerts.sendEmail) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendSMS: false
        })
      } else if (newUnitAlerts.sendSMS && !newUnitAlerts.sendEmail) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendSMS: false,
          isSubscribed: false
        })
      }
    }
  }

  // same as above but for the sendEmail element (this is passed directly from original logic into this new component. For the record, I don't like it and want to redo it. - Cat)
  const ouEmailCheck = () => {
    if (newUnitAlerts) {
      if (!newUnitAlerts.sendEmail && !newUnitAlerts.sendSMS) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendEmail: true,
          isSubscribed: true
        })
      } else if (!newUnitAlerts.sendEmail && newUnitAlerts.sendSMS) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendEmail: true
        })
      } else if (newUnitAlerts.sendEmail && newUnitAlerts.sendSMS) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendEmail: false
        })
      } else if (newUnitAlerts.sendEmail && !newUnitAlerts.sendSMS) {
        setNewUnitAlerts({
          ...newUnitAlerts,
          sendEmail: false,
          isSubscribed: false
        })
      }
    }
  }

  // this is used when they select the unit they wish to subscribe/unsubscribe to
  const handleUnitClick = (ancestors, key, isSelected, children = []) => {
    // using the children array, extract any and all nested child keys, ignoring all parents IDs where additional child keys are present
    const allChildKeys = keyify2(children, true) || []

    // if there are no child keys, just select the single unit
    if (!children.length) {
      HandleSingleUnitClick({ key, isSelected, newUnitAlerts, setNewUnitAlerts, noSMS })

      // otherwise, ignore the parent key and add or remove all of its children and sub children based on the value of the 'isSelected' argument
    } else {
      // for each child unit, add or remove it from the array based on if the parent was being selected or unselected
      const newSelections = allChildKeys.reduce((arr, childKey) => {
        // determine if the child key is already in the array
        const childIndex = arr.indexOf(childKey)

        // if we are selecting the parent, and the child key is not already in the array, add it
        if (!isSelected && childIndex === -1) {
          arr.push(childKey)
        }

        // if we are un-selecting the parent, and the child is currently in the array, remove it
        if (isSelected && childIndex !== -1) {
          arr.splice(childIndex, 1)
        }

        return arr
      }, [...newUnitAlerts?.selectedUnits])

      // set the new selected units to the local form
      setNewUnitAlerts({
        ...newUnitAlerts,
        selectedUnits: newSelections,
        ...(noSMS && { sendEmail: true, isSubscribed: true })
      })
    }
  }

  return (
    <Dialog onClick={(event) => event.stopPropagation()} fullWidth open={openUnits} onClose={handleOUCancel}>
      <DialogTitle disableTypography stye={{ textTransform: 'none' }}>
        <Typography variant='h5' color='primary' classes={{ colorPrimary: classes.blueText }} className='font-weight-bold'>Please Select Units</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container direction='column'>
          {/* This section renders differently based on if SMS is enabled or not. */}
          {noSMS
            ? (
              <Grid item container justify='center' direction='column' className='mb-3'>
                <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
                  Delivery Method:
                </Typography>
                <Typography variant='subtitle2' style={{ textTransform: 'none' }}>
                  SMS is currently disabled. Alerts will be delivered to the email address you provided.
                </Typography>
              </Grid>)
            : (
              <>
                <Grid item container justify='center'>
                  <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
                    Please Choose a Delivery Method for This Alert
                  </Typography>
                </Grid>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly' }}>
                  <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <GreenCheckbox size='small' checked={newUnitAlerts.sendSMS} onClick={(event) => { event.stopPropagation(); ouSmsCheck() }} />
                    <Typography color='primary' classes={{ colorPrimary: classes.blueText }} variant='subtitle2' style={{ textTransform: 'none', fontWeight: 'bold' }}>
                      SMS
                    </Typography>
                  </div>
                  <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <GreenCheckbox size='small' checked={newUnitAlerts.sendEmail} onClick={(event) => { event.stopPropagation(); ouEmailCheck() }} />
                    <Typography color='primary' classes={{ colorPrimary: classes.blueText }} variant='subtitle2' style={{ textTransform: 'none', fontWeight: 'bold' }}>
                      Email
                    </Typography>
                  </div>
                </div>
              </>)}
          <Grid item container justify='center' direction='column'>
            <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
              Available Units:
            </Typography>
          </Grid>
          {/* Maps through units available to User */}
          {
            TreeData.length
              ? (
                <TreeView disableSelection expanded={expandedKeys} className={classes.unitTree}>
                  <UnitTree
                    treeData={TreeData[0].children}
                    onUnitClick={handleUnitClick}
                    selectedKeys={newUnitAlerts.selectedUnits}
                    isCheckbox
                  />
                </TreeView>)
              : (<></>)
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        {noUnit &&
          <Typography color='error' variant='overline' style={{ textTransform: 'none' }}>* Please Select at Least one Unit</Typography>}
        {noDeliveryMethod &&
          <Typography color='error' variant='overline' style={{ textTransform: 'none' }}>* Please Select at Delivery Method</Typography>}
        <Button onClick={(event) => { event.stopPropagation(); handleOUCancel() }} variant='contained' className={classes.saveButton}>
          Cancel
        </Button>
        <Button onClick={(event) => { event.stopPropagation(); handleOUOk() }} variant='contained' className={classes.saveButton}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default OUAlertSelectionModal
